import React, { forwardRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useContext } from "react";
import { ConfigContext } from "../../context/GlobalContext";
import { DownloadDocument } from "./previewaction";
import LoaderView from "../LoaderView";
import { Languages } from "../../Utils/Languages";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ShareLinkView from "../ShareLinkView";
import { PremiumFeatureOnlyModal } from "../PremiumFeatureOnlyModal";
import MessageModel from "../MessageModel";
import { trackEvent, trackWhatsAppShare } from "../../Utils/EventTracker";
import SignatureModel from "../SignatureModel";
import { useLocation } from "react-router-dom";
import { logEvent } from '../../helper/shakebug';

const MainPreview = ({ selectedTemplate, selectedInvoice }) => {

    const { state, dispatch } = useContext(ConfigContext);
    const [showShareModal, setShowShareModal] = useState(false);

    // Map template IDs to components
    const navigate = useNavigate();
    const invoiceRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const [signatureUrl, setSignatureUrl] = useState(null);
    const [showPremiumModal, setShowPremiumModal] = useState(false);
    const [isShowWhatsappShareModel, setIsShowWhatsappShareModel] = useState(false);
    const [whatsappMessageType, setWhatsappMessageType] = useState(null);
    const [whatsappMessage, setWhatsappMessage] = useState(null);
    const [lockedFeature, setLockedFeature] = useState("");
    const [previewHtml, setPreviewHtml] = useState("");
    const [Item, setItem] = useState([]);
    const location = useLocation();
    const onPrintClick = () => {
        try {
            handlePrint();
        } catch (e) {
            console.error("❌ Print error:", e);
        }
    };

    const handleShare = async () => {
        try {
            const pdf = await DownloadDocument(
                setLoading,
                invoiceDownloadId,
                documentTitle,
                false // 👈 don't download
            );

            const pdfBlob = pdf.output("blob");

            const formData = new FormData();
            formData.append("file", pdfBlob, `${documentTitle}.pdf`);
            formData.append("userId", state?.USERID);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}upload-pdf`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            setFileUrl(response.data.filePath);
            setShowShareModal(true);

        } catch (error) {
            console.error("Share error:", error);
        }
    };

    const starterPlanName = process.env.REACT_APP_STARTER_PLAN_NAME;
    const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
    const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

    const userPlanName = state?.PAYMENT?.[state?.PAYMENT?.length - 1]?.planName?.trim();

    // ⭐ Effective plan logic (OLD plans = Starter)
    let newuserPlanName = starterPlanName;

    if (
        userPlanName === starterPlanName ||
        userPlanName === professionalPlanName ||
        userPlanName === agencyPlanName
    ) {
        newuserPlanName = userPlanName;
    }

    const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(selectedInvoice?.companyId));
    console.log("business", business);
    const isShared = business?.isShared === true;
    console.log("isShared", isShared);

    // ✅ Plan-specific feature access
    const hasWhatsAppAccess = isShared || (state?.PREMIUM && (
        newuserPlanName === starterPlanName ||
        newuserPlanName === professionalPlanName ||
        newuserPlanName === agencyPlanName
    ));

    const hasSignatureAccess = isShared || (state?.PREMIUM && (
        newuserPlanName === professionalPlanName ||
        newuserPlanName === agencyPlanName
    ));

    const invoiceDownloadId = selectedInvoice?.customInvoiceId || selectedInvoice?.id;

    // ❌ Overlay for Free + Starter
    // const showPremiumOverlay = (!state?.PREMIUM || !isProfessionalOrAgency) && !isShared;

    const handleWhatsApp = async () => {
        setLoading(true);

        const data = document.getElementById("divToPrint"); // or use `invoiceRef.current` if you're using ref

        if (!data) {
            console.error("Error: divToPrint not found!");
            setLoading(false);
            return;
        }

        try {
            // Reset CSS zoom so the PDF captures at full original size
            const prevZoom = data.style.zoom;
            data.style.zoom = "1";

            // Capture the element as a canvas
            const canvas = await html2canvas(data, {
                useCORS: true,
                allowTaint: true,
                scale: 2, // Higher quality
            });

            // Restore screen zoom after capture
            data.style.zoom = prevZoom;

            const imgData = canvas.toDataURL("image/png");

            // Create a new jsPDF instance
            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: "a4",
            });

            // Add image to PDF: adjust x, y, width, height as needed
            pdf.addImage(imgData, "PNG", 5, 5, 200, 290);

            // Get PDF blob (don't save/download)
            const pdfBlob = pdf.output("blob");


            const SelectedInvoice = selectedInvoice;

            const CustomerDetails = state?.CUSTOMERS?.find(customer => customer?.customerId == SelectedInvoice?.customerId);

            const BusinessDetails = state?.BUSINESSES?.find(business => business?.companyId == SelectedInvoice?.companyId);


            if (!CustomerDetails?.dialCode || !CustomerDetails?.phone) {
                setWhatsappMessageType("MISSING PHONE");
                setWhatsappMessage("Phone number with dial code is required to send a WhatsApp message.");
                setIsShowWhatsappShareModel(true);
            }

            else {
                // Determine the correct prefix and shareType for the document
                const prefixMap = {
                    "Invoice - List": "INV",
                    "Proforma Invoice - List": "PRO",
                    "Quotation - List": "QUO",
                    "Sales Return - List": "SR",
                };
                const prefix = prefixMap[state?.ACTIVEPAGE] || "INV";

                const shareTypeMap = {
                    "Invoice - List": "Invoice",
                    "Proforma Invoice - List": "Proforma Invoice",
                    "Quotation - List": "Quotation",
                    "Sales Return - List": "Sales Return",
                };
                const shareType = shareTypeMap[state?.ACTIVEPAGE] || "Invoice";

                // Prepare form data for API upload
                const formData = new FormData();
                formData.append("file", pdfBlob, `BillName_${Date.now()}.pdf`);
                formData.append("userId", state?.USERID);
                formData.append("business", BusinessDetails?.companyName);
                formData.append("invoice", `${SelectedInvoice?.customInvoiceId || SelectedInvoice?.id}`);
                formData.append("amount", `${state?.SYMBOL}${SelectedInvoice?.totalAmount}`);
                formData.append("customerName", CustomerDetails?.customer);
                formData.append("customerNumber", `${CustomerDetails?.dialCode}${CustomerDetails?.phone}`);
                formData.append("documentType", title);
                formData.append("shareType", shareType);

                const response = await axios.post(`${process.env.REACT_APP_BASE_URL}send-invoice`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (response?.data?.status) {
                    setWhatsappMessageType("SUCCESS");
                    setWhatsappMessage(response?.data?.message);
                    setIsShowWhatsappShareModel(true);
                    trackWhatsAppShare(SelectedInvoice?.invoiceId, `${CustomerDetails?.dialCode}${CustomerDetails?.phone}`, state?.USERID, "website", "website")
                }
                else {
                    setWhatsappMessageType("FAILED");
                    setWhatsappMessage(response?.data?.error);
                    setIsShowWhatsappShareModel(true);
                }

            }

        } catch (error) {
            setWhatsappMessageType("FAILED");
            setWhatsappMessage("Something went wrong while sending the invoice. Please try again.");
            setIsShowWhatsappShareModel(true);
            trackEvent("API_FAILED", { 'name': "send-invoice", "error": error })
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const shouldDownload = params.get("download");

        if (shouldDownload === "true") {
            setTimeout(() => {
                DownloadDocument(
                    setLoading,
                    invoiceDownloadId,
                    documentTitle,
                    true
                );
            }, 500);
        }
    }, []);

    useEffect(() => {

        const params = new URLSearchParams(location.search);

        const shouldPrint = params.get("print");
        const shouldDownload = params.get("download");
        const shouldWhatsapp = params.get("whatsapp");
        const shouldShare = params.get("share");

        setTimeout(() => {

            if (shouldPrint === "true") {
                onPrintClick();
            }

            if (shouldDownload === "true") {
                DownloadDocument(setLoading, invoiceDownloadId, documentTitle, true);
            }

            if (shouldWhatsapp === "true") {
                handleWhatsApp();
            }

            if (shouldShare === "true") {
                handleShare();
            }

        }, 500);

    }, []);
    useEffect(() => {
        if (!selectedInvoice?.items || !state?.ITEMS) return;

        const matchedItems = selectedInvoice.items.map((invItem) => {
            const matched = state.ITEMS.find(
                (item) =>
                    item.itemId?.toString() === invItem.itemId?.toString()
            );

            return {
                ...invItem,
                ...matched,
            };
        });

        setItem(matchedItems);
    }, [selectedInvoice, state?.ITEMS]);

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const shouldPrint = params.get("print");

        if (shouldPrint === "true") {
            setTimeout(() => {
                onPrintClick();
            }, 800);
        }

    }, [selectedInvoice]);
    useEffect(() => {
        const fetchPreview = async () => {
            try {
                setLoading(true);

                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}invoice/preview`,
                    {
                        mainHeader: title,
                        templateId: selectedTemplate,
                        invoice: selectedInvoice,
                        business: state?.BUSINESSES?.find(
                            b => b.companyId == selectedInvoice?.companyId
                        ),
                        customer: state?.CUSTOMERS?.find(
                            c => c.customerId == selectedInvoice?.customerId
                        ),
                        items: Item,
                        premium: state?.PREMIUM,
                        lang: state?.LANGUAGE,
                        taxType: state?.TAXTYPE,
                        symbol: state?.SYMBOL,
                        totalInWords: selectedInvoice?.totalInWords,
                        signatureUrl: signatureUrl
                    },
                    {
                        responseType: "text" // IMPORTANT
                    }
                );
                setPreviewHtml(response.data);

            } catch (error) {
                console.error("Preview error:", error.response?.data || error);
            } finally {
                setLoading(false);
            }
        };

        if (selectedInvoice && Item?.length > 0) {
            fetchPreview();
        }

    }, [selectedInvoice, selectedTemplate, signatureUrl, Item]);


    const PAGE_TITLE_MAP = {
        "Invoice - List": "INVOICE",
        "Proforma Invoice - List": "PROFORMA INVOICE",
        "Quotation - List": "QUOTATION",
        "Sales Return - List": "SALES RETURN",
    };

    const isSalesReturn = state?.ACTIVEPAGE === "Sales Return - List";

    const title = PAGE_TITLE_MAP[state?.ACTIVEPAGE] || "";


    const documentTitle = isSalesReturn
        ? `${invoiceDownloadId}`   // Only ID, no title, no underscore
        : `${title}_${invoiceDownloadId}`;

    // const handlePrint = useReactToPrint({
    //     content: () => invoiceRef.current,
    //     documentTitle,
    //     removeAfterPrint: true,
    //     onBeforeGetContent: () =>
    //         new Promise(resolve => {
    //             setTimeout(resolve, 300);
    //         }),
    // });

    const handlePrint = useReactToPrint({
        content: () => invoiceRef.current,
        documentTitle,
        pageStyle: `
        @page {
            size: A4;
            margin: 20mm;
        }
        @media print {
            body {
                -webkit-print-color-adjust: exact;
            }
        }
    `,
    });

    const EDIT_ROUTE_MAP = {
        "Invoice - List": "/invoice-edit",
        "Proforma Invoice - List": "/proformainvoic-edit",
        "Quotation - List": "/quotation-edit",
        "Sales Return - List": "/sales-return-edit",
    };

    const editRoute = EDIT_ROUTE_MAP[state?.ACTIVEPAGE] || "/invoice-edit";

    return (
        <>
            {loading && (
                <LoaderView />
            )}

            <div className="row bg-white  text-black  ms-1 overflow-x-hidden align-items-center">
                <div className="display_button d-flex d-lg-none align-items-center justify-content-between gap-3 no-printme">

                    {/* LEFT SIDE — Back Button */}
                    <button
                        type="button"
                        className="text-black d-flex align-items-center"
                        onClick={() => navigate(-1)}
                        style={{ border: "none", background: "transparent" }}
                    >
                        <Icon icon="ic:baseline-arrow-back" width="24" />
                    </button>

                    {/* RIGHT SIDE — All Action Buttons */}
                    <div className="d-flex flex-wrap justify-content-end gap-2">

                        {/* Edit Button */}
                        <button
                            onClick={() => navigate(editRoute)}
                            className="btn btn-sm btn-success radius-8 d-flex align-items-center gap-1"
                        >
                            <Icon icon="uil:edit" />
                        </button>

                        {/* Print Button */}
                        <button
                            onClick={onPrintClick}
                            type="button"
                            className="btn btn-sm btn-danger radius-8 d-flex align-items-center gap-1"
                        >
                            <Icon icon="basil:printer-outline" />
                        </button>

                        {/* Download Button */}
                        <button
                            onClick={() =>
                                DownloadDocument(setLoading, invoiceDownloadId, documentTitle, true)
                            }
                            className="btn btn-sm btn-warning radius-8 d-flex align-items-center gap-1"
                        >
                            <Icon icon="solar:download-linear" />
                        </button>

                        {/* WhatsApp Button */}
                        <button
                            onClick={() => {
                                if (hasWhatsAppAccess) {
                                    handleWhatsApp();
                                } else {
                                    setLockedFeature("WhatsApp");
                                    setShowPremiumModal(true);
                                }
                            }}
                            className="btn btn-sm radius-8 d-flex align-items-center justify-content-center position-relative overflow-hidden p-0"
                            style={{
                                backgroundColor: "#25D366",
                                color: "#fff",
                                width: "36px",
                                height: "36px"
                            }}
                        >
                            {!hasWhatsAppAccess && (
                                <>
                                    {/* Dark overlay */}
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{
                                            backgroundColor: "rgba(0,0,0,0.4)",
                                            zIndex: 1,
                                            pointerEvents: "none",
                                            borderRadius: "8px"
                                        }}
                                    />

                                    {/* Crown icon center */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="#ffc107"
                                        viewBox="0 0 24 24"
                                        width="18"
                                        height="18"
                                        style={{
                                            position: "absolute",
                                            zIndex: 2,
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            pointerEvents: "none"
                                        }}
                                    >
                                        <path d="M5 16L3 6l5 4 4-6 4 6 5-4-2 10H5zm0 2h14v2H5v-2z" />
                                    </svg>
                                </>
                            )}

                            <Icon
                                icon="ic:baseline-whatsapp"
                                width="20"
                                height="20"
                            />
                        </button>

                        {/* Share Button */}
                        <button
                            className="btn btn-sm radius-8 d-flex align-items-center gap-1"
                            style={{ backgroundColor: "#17a2b8", color: "#fff" }}
                            onClick={handleShare}
                        >
                            <Icon icon="mdi:share-variant"
                                width="20"
                                height="20" />
                        </button>

                        {/* Signature Button */}
                        <button
                            onClick={() => {
                                if (hasSignatureAccess) {
                                    setShowSignatureModal(true);
                                } else {
                                    setLockedFeature("Signature");
                                    setShowPremiumModal(true);
                                }
                            }}
                            className="btn btn-sm radius-8 d-flex align-items-center justify-content-center position-relative overflow-hidden p-0"
                            style={{ backgroundColor: '#4682B4', color: '#fff', width: "36px", height: "36px" }}
                        >
                            {!hasSignatureAccess && (
                                <>
                                    {/* Dark overlay */}
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{
                                            backgroundColor: "rgba(0,0,0,0.4)",
                                            zIndex: 1,
                                            pointerEvents: "none",
                                            borderRadius: "8px"
                                        }}
                                    />

                                    {/* Crown icon center */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="#ffc107"
                                        viewBox="0 0 24 24"
                                        width="18"
                                        height="18"
                                        style={{
                                            position: "absolute",
                                            zIndex: 2,
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            pointerEvents: "none"
                                        }}
                                    >
                                        <path d="M5 16L3 6l5 4 4-6 4 6 5-4-2 10H5zm0 2h14v2H5v-2z" />
                                    </svg>
                                </>
                            )}

                            {/* Original Icon */}
                            <Icon
                                icon="mdi:draw-pen"
                                width="20"
                                height="20"
                            />
                        </button>
                    </div>

                </div>


            </div>

            <div
                className="row align-items-start g-3"
                style={{ marginLeft: "2%", marginTop: "1%" }}
            >

                {/* 🔙 LEFT SIDE - Back Button */}
                <div className="col-lg-1 d-none d-lg-flex flex-column no-printme">
                    <Link
                        onClick={() => navigate(-1)}
                        to="#"
                        className="btn btn-sm btn-secondary d-flex align-items-center gap-1 justify-content-center"
                    >
                        <Icon icon="ic:baseline-arrow-back" />
                        {Languages[state?.LANGUAGE].back}
                    </Link>
                </div>


                {/* 📄 CENTER - Invoice Preview */}

                <div
                    className="print-content col-12 col-lg-9 bg-white"
                    id="divToPrint"
                    ref={invoiceRef}
                    dangerouslySetInnerHTML={{ __html: previewHtml }}
                />


                {/* 🎯 RIGHT SIDE - Action Buttons */}
                <div className="col-lg-2 d-none d-lg-flex flex-column gap-3 no-printme">

                    <button
                        onClick={() => navigate(editRoute)}
                        className="btn btn-sm btn-success d-flex align-items-center gap-1 justify-content-center"
                    >
                        <Icon icon="uil:edit" />
                        {Languages[state?.LANGUAGE].edit}
                    </button>

                    <button
                        onClick={() => onPrintClick()}
                        className="btn btn-sm btn-danger d-flex align-items-center gap-1 justify-content-center"
                    >
                        <Icon icon="basil:printer-outline" />
                        {Languages[state?.LANGUAGE].print}
                    </button>

                    <button
                        className="btn btn-sm btn-warning d-flex align-items-center gap-1 justify-content-center"
                        onClick={() =>
                            DownloadDocument(setLoading, invoiceDownloadId, documentTitle, true)
                        }
                    >
                        <Icon icon="solar:download-linear" />
                        {Languages[state?.LANGUAGE].download}
                    </button>

                    {/* WhatsApp Button (Logic SAME) */}
                    <button
                        className="btn btn-sm d-flex align-items-center gap-1 position-relative overflow-hidden justify-content-center"
                        style={{ backgroundColor: '#25D366', color: '#fff' }}
                        onClick={() => {
                            logEvent("User Action", "Share invoice");
                            if (!hasWhatsAppAccess) {
                                setLockedFeature("WhatsApp")
                                setShowPremiumModal(true);
                            } else {
                                handleWhatsApp();
                            }
                        }}
                    >
                        {/* Overlay logic unchanged */}
                        {!hasWhatsAppAccess && (
                            <>
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 "
                                    style={{
                                        backgroundColor: "rgba(0,0,0,0.4)",
                                        zIndex: 1,
                                        pointerEvents: "none"
                                    }}
                                />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#ffc107"
                                    viewBox="0 0 24 24"
                                    width="22"
                                    height="22"
                                    style={{
                                        position: "absolute",
                                        zIndex: 2,
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        pointerEvents: "none"
                                    }}
                                >
                                    <path d="M5 16L3 6l5 4 4-6 4 6 5-4-2 10H5zm0 2h14v2H5v-2z" />
                                </svg>
                            </>
                        )}

                        <Icon icon="ic:baseline-whatsapp" />
                        WhatsApp
                    </button>

                    <button
                        className="btn btn-sm d-flex align-items-center gap-1 justify-content-center position-relative overflow-hidden"
                        style={{ backgroundColor: '#17a2b8', color: '#fff' }}
                        onClick={handleShare}
                    >
                        <Icon icon="mdi:share-variant" />
                        Share
                    </button>

                    <button
                        onClick={() => {
                            if (hasSignatureAccess) {
                                setShowSignatureModal(true);
                            } else {
                                setLockedFeature("Signature")
                                setShowPremiumModal(true);
                            }
                        }}
                        className="btn btn-sm d-flex align-items-center gap-1 position-relative overflow-hidden justify-content-center"
                        style={{ backgroundColor: '#4682B4', color: '#fff' }}
                    >
                        {!hasSignatureAccess && (
                            <>
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 "
                                    style={{
                                        backgroundColor: "rgba(0,0,0,0.4)",
                                        zIndex: 1,
                                        pointerEvents: "none"
                                    }}
                                />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#ffc107"
                                    viewBox="0 0 24 24"
                                    width="22"
                                    height="22"
                                    style={{
                                        position: "absolute",
                                        zIndex: 2,
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        pointerEvents: "none"
                                    }}
                                >
                                    <path d="M5 16L3 6l5 4 4-6 4 6 5-4-2 10H5zm0 2h14v2H5v-2z" />
                                </svg>
                            </>
                        )}
                        <Icon icon="mdi:draw-pen" />
                        Signature
                    </button>

                </div>
                <SignatureModel
                    show={showSignatureModal}          // controls modal visibility
                    setShow={setShowSignatureModal}    // to close modal
                    setSignatureUrl={setSignatureUrl} // to save signature from modal
                    customerData={{ name: "John Doe" }} // optional
                />
                {fileUrl && (
                    <ShareLinkView
                        fileUrl={fileUrl}
                        show={showShareModal}
                        setShow={setShowShareModal}
                        customerData={{ "name": selectedInvoice?.customer, "phone": selectedInvoice?.phone, "email": selectedInvoice?.email, "business": state?.BUSINESSES?.find(business => business?.companyId == selectedInvoice?.companyId)?.companyName }}
                    />
                )}

                <PremiumFeatureOnlyModal
                    isOpen={showPremiumModal}
                    onClose={() => setShowPremiumModal(false)}
                    featureName={lockedFeature}
                />

                <MessageModel
                    showModal={isShowWhatsappShareModel}
                    setShowModal={setIsShowWhatsappShareModel}
                    type={whatsappMessageType}
                    message={whatsappMessage}
                />
            </div>
        </>
    );
};

export default MainPreview;
